import { EventType, Features, SourcePages } from 'lib/EventSchema';
import { EventContext, EventData } from 'lib/EventLogger/Event';

export type OnboardingTapAction = 'onboarding_start' | 'close' | 'leave' | 'cancel' | 'next';

interface OnboardingTapEventInfo {
  action: OnboardingTapAction;
  sourcePage: SourcePages;
  eventContext?: EventContext;
}

function event({ action, sourcePage, eventContext }: OnboardingTapEventInfo): EventData {
  return {
    source_page: sourcePage,
    feature: Features.onboarding,
    event_type: EventType.engagement,
    engagement_type: `${action}_tap`,
    event_context: eventContext,
  };
}

export default event;
